import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { Root as ProductInfoRoot } from '../../../SearchPreview/components/SearchPreviewProduct/components/ProductInfo/styles';
import { Info, Inner, Price, PriceAndButton } from '../../../SearchPreview/components/SearchPreviewProduct/styles';
import { UnifiedSkeleton } from '../../../styles';
import { SEARCH_PREVIEW_PRODUCT_SKELETON } from './constants';
import { ImageSkeleton, QuickBuyButtonSkeleton, Root } from './styles';
import { type SearchPreviewProductSkeletonProps } from './types';

export const SearchPreviewProductSkeleton: FC<SearchPreviewProductSkeletonProps> = ({ animation, className }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      className={className}
      data-testid={getTestId(SEARCH_PREVIEW_PRODUCT_SKELETON)}
    >
      <ImageSkeleton animation={animation} />
      <Inner>
        <Info>
          <ProductInfoRoot>
            <UnifiedSkeleton
              variant="text"
              height={15}
              width={60}
              animation={animation}
            />
            <UnifiedSkeleton
              variant="text"
              height={19}
              width="40%"
              animation={animation}
            />
            <UnifiedSkeleton
              variant="text"
              height={19}
              width={35}
              animation={animation}
            />
          </ProductInfoRoot>
        </Info>
        <PriceAndButton>
          <Price>
            <UnifiedSkeleton
              variant="text"
              height={19}
              width={40}
              animation={animation}
            />
          </Price>
          <QuickBuyButtonSkeleton
            variant="circular"
            animation={animation}
          />
        </PriceAndButton>
      </Inner>
    </Root>
  );
};
